<script lang="ts" setup>
	const isOpen = defineModel<boolean>({
		default: false
	})

	const businessLoginUrl = import.meta.env.VITE_BUSINESS_URL + '/claims'
	const individualLoginUrl = import.meta.env.VITE_INDIVIDUAL_URL + '/more?tab=claims'
	const authRoutes = ref([
		{
			title: 'Business account',
			description: 'Log in to your business account to make a claim on active plans for your business assets',
			src: businessLoginUrl,
			icon: {
				name: 'briefcase',
				dir: 'fill'
			}
		},

		{
			title: 'Personal account',
			description:
				'Log in to your personal account to make a claim on active plans for yourself or your loved ones',
			src: individualLoginUrl,
			icon: {
				name: 'persons',
				dir: 'fill'
			}
		}
	])
</script>

<template>
	<ui-modal v-model:show="isOpen">
		<div class="mx-auto w-full text-[#094163]">
			<ui-title-header
				title="LogIn To Make A Claim!"
				class="py-8 max-w-[700px] mx-auto border-b broder-gray-100 custom-transition-2 dark:border-gray-700"
				:ui="{ size: 'sm:text-[3em] text-[1.5em] text-center' }"
			/>

			<div class="flex mx-auto w-full py-10 px-5 max-w-[1000px] md:justify-between justify-center items-center">
				<span class="hidden md:block">
					<tools-icon dir="random" icon="signature-note" width="364" height="364" />
				</span>

				<div class="gap-10 space-y-8">
					<nuxt-link
						v-for="(link, index) in authRoutes"
						:key="index"
						:to="link.src"
						class="max-w-[460px] relative w-full min-h-[178px] bg-inherit group custom-transition-2 dark:border-gray-700 hover:bg-base-50 hover:dark:bg-gray-800 block hover:border-main border border-gray-200 rounded-[4px] p-5 md:p-[24px_59px_24px_24px] flex-none"
					>
						<div
							class="h-[54px] w-[54px] custom-transition-2 flex items-center justify-center group-hover:bg-white rounded-full bg-base-50"
						>
							<tools-icon :icon="link.icon.name" :dir="link.icon.dir" :height="24" :width="24" />
						</div>

						<div class="mt-5 space-y-3">
							<h4 class="font-semibold sm:text-lg text-base text-blue-950 dark:text-main">
								{{ link.title }}
							</h4>
							<p class="text-sm text-gray-600 dark:text-gray-400">
								{{ link.description }}
							</p>
							<div class="relative custom-transition-2 animate-x opacity-0 group-hover:opacity-100">
								<tools-icon
									icon="arrow-short-r"
									dir="arrows"
									path-class="fill-gray-700 dark:fill-gray-400"
								/>
							</div>
						</div>
					</nuxt-link>
				</div>
			</div>
		</div>
	</ui-modal>
</template>

<style scoped>
	@keyframes moveX {
		0% {
			transform: translateX(0);
		}

		10%,
		30% {
			transform: translateX(-5px);
		}

		55%,
		70% {
			transform: translateX(-5px);
			transform-origin: 0 5px;
		}

		80%,
		100% {
			transform: translateX(0px);
		}
	}
	.animate-x {
		animation: moveX 1.5s linear infinite;
		transform-origin: center;
		transform-style: preserve-3d;
	}
</style>
